import React, { createContext, useState, ReactNode } from 'react'

interface PolicyOptInsContextType {
  suppressPolicyOptIns: boolean
  setSuppressPolicyOptIns: (suppress: boolean) => void
}

const PolicyOptInsContext = createContext<PolicyOptInsContextType | undefined>(undefined)

interface PolicyOptInsProviderProps {
  children: ReactNode
}

export const PolicyOptInsProvider: React.FC<PolicyOptInsProviderProps> = ({ children }) => {
  const [suppressPolicyOptIns, setSuppressPolicyOptIns] = useState(false)

  return (
    <PolicyOptInsContext.Provider value={{ suppressPolicyOptIns, setSuppressPolicyOptIns }}>
      {children}
    </PolicyOptInsContext.Provider>
  )
}

export default PolicyOptInsProvider